import React from 'react'
import { useTranslation } from 'react-i18next'
import { numberWithCommas } from '@/utils/numberWithCommas'

export type TooltipItemProps = {
    label: string
    value: number | string | undefined
    color: string
    showHigh?: boolean
}

export const TooltipItem: React.FC<TooltipItemProps> = ({
    label,
    value,
    color,
    showHigh = false,
}) => {
    const { t } = useTranslation('translations')
    const formattedValue =
        typeof value === 'number' ? numberWithCommas(value, 2) : (value ?? '-')
    const highLabel = t(
        'active_management.interval.chart_tooltip.high_indicator'
    )

    return (
        <>
            <div className="flex min-w-0 items-center gap-1">
                <div
                    className="h-2 w-2 shrink-0 rounded-full bg-[currentColor]"
                    style={{ color }}
                />
                <div className="text-label-xsmall min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
                    {label}
                </div>
            </div>
            <div className="text-body-small text-right tabular-nums">
                {formattedValue}
            </div>
            {showHigh ? (
                <span
                    className="text-label-xxsmall shrink-0 rounded bg-red-50 px-1 py-0.5 text-red-500"
                    data-testid="tooltip-high-indicator"
                >
                    ↑ {highLabel}
                </span>
            ) : (
                <span className="shrink-0" />
            )}
        </>
    )
}
